import { gql } from '@apollo/client';

export const PROJECT_FIELDS = gql`
  fragment ProjectFields on Project {
    id
    projectId
    addressId
    name
    projectStageId
    ownerId
    signingDate
    estimatedDay1Date
    day1StartDate
    warrantyExpirationDate
    projectLostReasonId
    lostReasonNotes
    partnerId
    isPrimary
    createdAt
    updatedAt
  }
`;
